/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Locked_FableInputs */

const en_model_locked_fable = /** @type {(inputs: Model_Locked_FableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available on the Fable plan`)
};

const id_model_locked_fable = /** @type {(inputs: Model_Locked_FableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersedia di paket Fable`)
};

/**
* | output |
* | --- |
* | "Available on the Fable plan" |
*
* @param {Model_Locked_FableInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_locked_fable = /** @type {((inputs?: Model_Locked_FableInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Locked_FableInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_locked_fable(inputs)
	return en_model_locked_fable(inputs)
});